import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    // here we will place our translations...
                    Metodo: 'Method',
                    description: {
                        context: 'Contextual information',
                        contextInfo: {
                            name: 'Name of the operator',
                            contact: 'Email',
                            country: 'Country',
                            city: 'City',
                            institution: 'Institution',
                            origin: 'Sample origin',
                            chronology: 'Chronology',
                            code: 'Code',
                            sex: 'Sex',
                            age: 'Documented Age',
                            type: 'Tooth type',
                            observation: 'Observations',
                            rl: 'RL',
                            pr: 'PR',
                            rdt: 'RDT',
                            
                        },
                        select: 'Please Select',
                        tooth: {
                            FULI: '	First upper left incisor',
                            FURI: '	First upper right incisor',
                            SULI: '	Second upper left incisor',
                            SURI: '	Secon upper right incisor',
                            ULC: '	Upper left canine',
                            URC: '	Upper right canine',
                            FULP: '	First upper left premolar',
                            FURP: '	First upper right premolar',
                            SULP: '	Second upper left premolar',
                            SURP: '	Second upper right premolar',
                            FLLI: '	First lower left incisor',
                            FLRI: '	First lower right incisor',
                            SLLI: '	Second lower left incisor',
                            SLRI: '	Secon lower right incisor',
                            LLC: '	Lower left canine',
                            LRC: '	Lower right canine',
                            FLLP: '	First lower left premolar',
                            FLRP: '	First lower right premolar',
                            SLLP: '	Second lower left premolar',
                            SLRP: '	Second lower right premolar',
                        },
                        metricData: 'Metric Data',
                        calculate: 'Calculate',
                        metricDataHelp: {
                            rl: 'Root Length',
                            pr: 'Periodontal recession',
                            rdt: 'Root Dentin Translucency'
                        },
                        tableResults: {
                            estAge: 'Estimated age',
                            estCorrAge: 'Corrected estimated age',
                            LIm: 'Lower limit',
                            LSm: 'Upper limit'
                        },
                        captchaTitle: 'Enter alphanumeric characters, it is case sensitive.',
                        captchaButton: 'Ok',
                        captchaReload: 'Reload Captcha',
                        references: 'References:',
                        tablefoot: 'Note: The range between the Middle lower limit and the Middle upper limit includes the 95% of the possible estimated ages',
                        tablefootnote1: 'The variables RL, PR, and RDT are included (Luna et al. 2024).',
                        tablefootnote2: 'Only the variables RDT and RL are considered. In this case, enter "0" for the variable PR.',
                        tablefootnote3: 'The variables RDT and RL are considered, logarithmically transformed (Parra et al. 2025). In this case, enter "0" for the variable RP.',
                        tablefootnote4: 'Luna, L. et al. 2024. Forensic International Dental Database (FIDBv2) for adult age-at-death estimation in multiple forensic contexts: Strengthening the operationalization of the Lamendin criteria in a global scope model. Forensic Science International 364: 112230. https://doi.org/10.1016/j.forsciint.2024.112230.',
                        tablefootnote5: 'Parra, R. et al. 2025. Improvement of the Forensic International Dental Database (FIDB) for adult age-at-death estimation using root dentin translucency: A simplified alternative methodology. Forensic Science International 369: 112433. https://doi.org/10.1016/j.forsciint.2025.112433.',
                        recommendation:'(Use points for decimals)' 
                    }
                }
            },
            es: {
                translation: {
                    // here we will place our translations...
                    Metodo: 'Método',
                    description: {
                        context: 'Información contextual',
                        contextInfo: {
                            name: 'Nombre del operador',
                            contact: 'Correo electrónico',
                            country: 'País',
                            city: 'Ciudad',
                            institution: 'Institución',
                            origin: 'Procedencia de la muestra',
                            chronology: 'Cronología',
                            code: 'Código',
                            sex: 'Sexo',
                            age: 'Edad documentada',
                            type: 'Tipo de diente',
                            observation: 'Observaciones',
                            rl: 'LR',
                            pr: 'RP',
                            rdt: 'TDR'
                        },
                        select: 'Seleccione',
                        tooth: {
                            FULI: '	Primer incisivo superior izquierdo',
                            FURI: '	Primer incisivo superior derecho',
                            SULI: '	Segundo incisivo superior izquierdo',
                            SURI: '	Segundo incisivo superior derecho',
                            ULC: '	Canino superior izquierdo',
                            URC: '	Canino superior derecho',
                            FULP: '	Primer premolar superior izquierdo',
                            FURP: '	Primer premolar superior derecho',
                            SULP: '	Segundo premolar superior izquierdo',
                            SURP: '	Segundo premolar superior derecho',
                            FLLI: '	Primer incisivo inferior izquierdo',
                            FLRI: '	Primer incisivo inferior derecho',
                            SLLI: '	Segundo incisivo inferior izquierdo',
                            SLRI: '	Segundo incisivo inferior derecho',
                            LLC: '	Canino inferior izquierdo',
                            LRC: '	Canino inferior derecho',
                            FLLP: '	Primer premolar inferior izquierdo',
                            FLRP: '	Primer premolar inferior derecho',
                            SLLP: '	Segundo premolar inferior izquierdo',
                            SLRP: '	Segundo premolar inferior derecho',
                        },
                        metricData: 'Datos métricos',
                        calculate: 'Calcular',
                        metricDataHelp: {
                            rl: 'Longitud de la Raíz',
                            pr: 'Retracción periodontal',
                            rdt: 'Translucencia dentinal de la raíz'
                        },
                        tableResults: {
                            estAge: 'Edad estimada',
                            estCorrAge: 'Edad estimada corregida',
                            LIm: 'Límite inferior',
                            LSm: 'Límite superior'
                        },
                        captchaTitle: 'Ingrese caracteres alfanuméricos, distingue entre mayúsculas y minúsculas',
                        captchaButton: 'Validar',
                        captchaReload: 'Recargar Captcha',
                        references: 'Referencias:',
                        tablefoot: 'Nota: El rango de valores entre el Límite inferior medio y el Límite superior medio incluye el 95% de las edades estimadas posibles',
                        tablefootnote1: 'Se incluyen las variables LR, RP y TDR (Luna et al. 2024).',
                        tablefootnote2: 'Solo se consideran las variables TDR y LR. En este caso, ingresar “0” para la variable RP.',
                        tablefootnote3: 'Se consideran las variables TDR y LR transformadas en forma logarítmica (Parra et al. 2025). En este caso, ingresar “0” para la variable RP.',
                        tablefootnote4: 'Luna, L. et al. 2024. Forensic International Dental Database (FIDBv2) for adult age-at-death estimation in multiple forensic contexts: Strengthening the operationalization of the Lamendin criteria in a global scope model. Forensic Science International 364: 112230. https://doi.org/10.1016/j.forsciint.2024.112230.',
                        tablefootnote5: 'Parra, R. et al. 2025. Improvement of the Forensic International Dental Database (FIDB) for adult age-at-death estimation using root dentin translucency: A simplified alternative methodology. Forensic Science International 369: 112433. https://doi.org/10.1016/j.forsciint.2025.112433.',   
                        recommendation:'(usar puntos para los decimales)'
                    }
                }
            }
        }
    });

export default i18n;
